import type { FC } from 'react'

import ReadyDataAI from './readyDataAI.svg'
import PredictiveAI from './predictiveAI.svg'
import GenerativeAI from './generativeAI.svg'

type OverviewBoxData = {
  icon: FC
  headline: string
  description: string
}

interface OverviewData {
  items: Array<OverviewBoxData>
}

const data: OverviewData = {
  items: [
    {
      icon: ReadyDataAI,
      headline: `Gain a deeper understanding of your customer with trusted data built on relationships`,
      description: `Understand the nuances and complexities of every customer’s relationship to your brand, their household, account teams, and the world around them with enriched and extended golden profiles.`,
    },
    {
      icon: PredictiveAI,
      headline: `Put accessible and actionable AI at marketers’ fingertips`,
      description: `Quickly and easily launch precisely targeted and timely campaigns—without the help of data teams—by putting the power of predictive AI directly in the hands of marketers.`,
    },
    {
      icon: GenerativeAI,
      headline: `Create, activate, and iterate faster for better results`,
      description: `Build the most engaging campaigns in minutes with customer-aware generative AI that automates who to target, how to build the journey, and what messages will resonate best with real-time insights for better results.`,
    },
  ],
}

export default data
